// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guided-run-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.guided-run-modal {
  background: var(--background-color);
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid var(--border-color);
}

.guided-run-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid var(--border-color);
  background: var(--secondary-background);
}

.guided-run-header h2 {
  margin: 0;
  color: var(--text-color);
  font-size: 1.5rem;
}

.guided-run-header .close-btn {
  background: none;
  border: none;
  font-size: 2rem;
  color: var(--text-color);
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.guided-run-header .close-btn:hover {
  background-color: var(--hover-color);
}

.progress-bar {
  display: flex;
  padding: 20px 30px;
  background: var(--secondary-background);
  border-bottom: 1px solid var(--border-color);
  overflow-x: auto;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  min-width: 80px;
  position: relative;
}

.progress-step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 15px;
  left: 60px;
  width: 20px;
  height: 2px;
  background-color: var(--border-color);
  z-index: 1;
}

.progress-step.active:not(:last-child)::after {
  background-color: var(--primary-color);
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--border-color);
  color: var(--text-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 5px;
  z-index: 2;
  position: relative;
}

.progress-step.active .step-number {
  background-color: var(--primary-color);
  color: white;
}

.progress-step.current .step-number {
  background-color: var(--accent-color);
  color: white;
  box-shadow: 0 0 10px var(--accent-color);
}

.step-label {
  font-size: 0.8rem;
  color: var(--text-secondary);
  text-align: center;
}

.progress-step.active .step-label {
  color: var(--text-color);
}

.guided-run-content {
  padding: 30px;
  max-height: calc(90vh - 200px);
  overflow-y: auto;
}

.guided-step {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.guided-step h3 {
  margin: 0 0 15px 0;
  color: var(--text-color);
  font-size: 1.3rem;
}

.guided-step p {
  margin: 0 0 20px 0;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* Study Cards */
.study-cards {
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
}

.study-card {
  border: 2px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s;
  background: var(--background-color);
}

.study-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.study-card.selected {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.study-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.study-header h4 {
  margin: 0;
  color: var(--text-color);
  font-size: 1.1rem;
}

.study-badge {
  background: var(--primary-color);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: bold;
}

.study-description {
  margin: 0 0 15px 0;
  color: var(--text-secondary);
  line-height: 1.4;
}

.study-links a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

.study-links a:hover {
  text-decoration: underline;
}

.study-assets {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

/* Dataset and Document Grids */
.dataset-grid, .document-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
}

.dataset-card, .document-card {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s;
  background: var(--background-color);
  display: flex;
  align-items: center;
  gap: 12px;
}

.dataset-card:hover, .document-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dataset-card.selected, .document-card.selected {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.dataset-icon, .document-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.dataset-info, .document-info {
  flex: 1 1;
}

.dataset-info h4, .document-info h4 {
  margin: 0 0 5px 0;
  color: var(--text-color);
  font-size: 1rem;
}

.dataset-info p, .document-info p {
  margin: 0 0 5px 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.dataset-size, .document-size {
  font-size: 0.8rem;
  color: var(--text-muted);
}

/* Preview Containers */
.preview-container {
  margin-top: 20px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  background: var(--secondary-background);
}

.preview-container h4 {
  margin: 0 0 15px 0;
  color: var(--text-color);
}

.table-container {
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

.preview-table, .results-table-content {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.preview-table th, .preview-table td,
.results-table-content th, .results-table-content td {
  border: 1px solid var(--border-color);
  padding: 8px;
  text-align: left;
}

.preview-table th, .results-table-content th {
  background: var(--secondary-background);
  font-weight: bold;
  color: var(--text-color);
}

.preview-table td, .results-table-content td {
  color: var(--text-secondary);
}

.document-preview {
  border: 1px solid var(--border-color);
  border-radius: 4px;
  overflow: hidden;
}

/* Analysis Question */
.analysis-question {
  margin-bottom: 30px;
}

.question-card {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  background: var(--secondary-background);
}

.question-card p {
  margin: 0 0 10px 0;
}

.question-card p:last-child {
  margin: 0;
}

/* SAP Section */
.sap-section {
  margin-bottom: 30px;
}

.sap-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 20px;
}

.sap-btn:hover:not(:disabled) {
  background: var(--primary-dark);
}

.sap-btn:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.sap-results {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  background: var(--secondary-background);
}

.sap-results h4 {
  margin: 0 0 15px 0;
  color: var(--text-color);
}

.sap-content pre {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 15px;
  overflow-x: auto;
  font-size: 0.9rem;
  color: var(--text-color);
  margin: 0;
}

/* SAP Loading Styles */
.sap-loading {
  margin-top: 20px;
  padding: 30px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--secondary-background);
}

.loading-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.loading-message p {
  margin: 0;
  font-size: 1.1rem;
  color: var(--text-color);
  font-weight: 500;
}

.loading-subtitle {
  font-size: 0.9rem !important;
  color: var(--text-secondary) !important;
  font-weight: 400 !important;
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
  display: inline-block;
  flex-shrink: 0;
}

.sap-loading .spinner {
  width: 24px;
  height: 24px;
  border: 3px solid var(--border-color);
  border-top: 3px solid var(--primary-color);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* SAP Content Markdown Styling */
.sap-content {
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.sap-content h1,
.sap-content h2,
.sap-content h3,
.sap-content h4,
.sap-content h5,
.sap-content h6 {
  color: var(--text-color);
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 600;
}

.sap-content h1:first-child,
.sap-content h2:first-child,
.sap-content h3:first-child {
  margin-top: 0;
}

.sap-content p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 12px;
}

.sap-content ul,
.sap-content ol {
  color: var(--text-secondary);
  padding-left: 20px;
  margin-bottom: 12px;
}

.sap-content li {
  margin-bottom: 6px;
}

.sap-content strong {
  color: var(--accent-color);
  font-weight: 600;
}

.sap-content code {
  background: var(--background-color);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9em;
  color: var(--text-color);
  border: 1px solid var(--border-color);
}

.sap-content pre {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 15px;
  overflow-x: auto;
  margin: 15px 0;
}

.sap-content pre code {
  background: none;
  border: none;
  padding: 0;
}

/* Code Generation */
.code-generation {
  margin-bottom: 30px;
}

/* R Code Loading Styles */
.r-code-loading {
  margin-top: 20px;
  padding: 30px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--secondary-background);
}

/* Code Actions */
.code-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.toggle-code-btn,
.copy-code-btn {
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.toggle-code-btn:hover,
.copy-code-btn:hover {
  background: var(--hover-color);
  border-color: var(--primary-color);
}

.copy-code-btn {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.copy-code-btn:hover {
  background: var(--primary-dark);
}

/* R Code Display */
.r-code-pre {
  background: #1e1e1e !important;
  color: #d4d4d4 !important;
  padding: 20px !important;
  border-radius: 8px !important;
  overflow-x: auto !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  border: 1px solid #333 !important;
  margin: 15px 0 !important;
}

.r-code-inline {
  background: var(--secondary-background) !important;
  color: var(--text-color) !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  font-size: 0.9em !important;
  border: 1px solid var(--border-color) !important;
}

/* Raw Code Section */
.raw-code-section {
  margin-top: 20px;
  padding: 15px;
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
}

.raw-code-section h5 {
  margin: 0 0 10px 0;
  color: var(--text-color);
  font-size: 1rem;
}

.raw-code {
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 15px;
  border-radius: 6px;
  overflow-x: auto;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.4;
  border: 1px solid #333;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Code Content */
.code-content {
  margin-top: 15px;
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
}

/* Dark theme overrides for code */
[data-theme="dark"] .r-code-pre {
  background: #0d1117 !important;
  color: #c9d1d9 !important;
  border-color: #30363d !important;
}

[data-theme="dark"] .raw-code {
  background: #0d1117;
  color: #c9d1d9;
  border-color: #30363d;
}

[data-theme="dark"] .code-content {
  background: var(--secondary-background);
  border-color: var(--border-color);
}

/* Light theme overrides for code */
[data-theme="light"] .r-code-pre {
  background: #f6f8fa !important;
  color: #24292f !important;
  border-color: #d0d7de !important;
}

[data-theme="light"] .raw-code {
  background: #f6f8fa;
  color: #24292f;
  border-color: #d0d7de;
}

.generate-btn, .run-btn {
  background: var(--accent-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 20px;
}

.generate-btn:hover:not(:disabled), .run-btn:hover:not(:disabled) {
  background: var(--accent-dark);
}

.generate-btn:disabled, .run-btn:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.code-results {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  background: var(--secondary-background);
}

.code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.code-header h4 {
  margin: 0;
  color: var(--text-color);
}

.toggle-btn {
  background: var(--secondary-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.toggle-btn:hover {
  background: var(--hover-color);
}

.code-content {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 15px;
  overflow-x: auto;
}

.code-content pre {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-color);
  white-space: pre-wrap;
}

/* Analysis Results */
.analysis-execution {
  margin-bottom: 30px;
}

.analysis-results {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  background: var(--secondary-background);
  margin-top: 20px;
}

.analysis-results h4 {
  margin: 0 0 15px 0;
  color: var(--text-color);
}

.results-content h5 {
  margin: 0 0 10px 0;
  color: var(--text-color);
}

.result-file {
  margin: 10px 0;
}

.download-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  display: inline-block;
  transition: all 0.2s;
}

.download-link:hover {
  background: var(--primary-color);
  color: white;
}

/* Enhanced Analysis Results */
.results-content {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* R Output Section */
.r-output-section {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 15px;
}

.r-output-section h5 {
  margin: 0 0 15px 0;
  color: var(--text-color);
  font-size: 1rem;
  font-weight: 600;
}

.output-container {
  background: #1e1e1e;
  border: 1px solid #333;
  border-radius: 6px;
  padding: 15px;
  overflow-x: auto;
}

.r-output {
  color: #d4d4d4;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Enhanced Results Table */
.results-table {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 15px;
}

.results-table h5 {
  margin: 0 0 15px 0;
  color: var(--text-color);
  font-size: 1rem;
  font-weight: 600;
}

.table-container {
  overflow-x: auto;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--background-color);
}

.results-table-content {
  width: 100%;
  border-collapse: collapse;
  background: var(--background-color);
  min-width: 600px;
}

.results-table-content th,
.results-table-content td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
}

.results-table-content th {
  background: var(--secondary-background);
  font-weight: 600;
  color: var(--text-color);
  font-size: 0.9rem;
}

.results-table-content td {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.results-table-content tr:hover {
  background: var(--hover-color);
}

/* Enhanced Generated Files */
.generated-files {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 15px;
}

.generated-files h5 {
  margin: 0 0 15px 0;
  color: var(--text-color);
  font-size: 1rem;
  font-weight: 600;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.result-file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  transition: all 0.2s ease;
  margin: 0;
}

.result-file:hover {
  background: var(--hover-color);
  border-color: var(--primary-color);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-icon {
  font-size: 1.2rem;
}

.file-name {
  font-weight: 500;
  color: var(--text-color);
}

.file-type {
  font-size: 0.8rem;
  color: var(--text-muted);
  background: var(--background-color);
  padding: 2px 6px;
  border-radius: 3px;
}

/* File Actions */
.file-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.view-file-btn {
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-file-btn:hover {
  background: var(--hover-color);
  border-color: var(--primary-color);
}

/* RTF Viewer Modal */
.rtf-viewer-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.rtf-viewer-content {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  width: 100%;
  max-width: 900px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.rtf-viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
  background: var(--secondary-background);
}

.rtf-viewer-header h3 {
  margin: 0;
  color: var(--text-color);
  font-size: 1.2rem;
}

.close-rtf-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-rtf-btn:hover {
  background: var(--hover-color);
  color: var(--text-color);
}

.rtf-viewer-body {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.rtf-file-info {
  padding: 15px 20px;
  background: var(--secondary-background);
  border-bottom: 1px solid var(--border-color);
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.rtf-content {
  flex: 1 1;
  overflow: auto;
  padding: 20px;
}

.rtf-content pre {
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 20px;
  margin: 0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-color);
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 400px;
  overflow-y: auto;
}

.rtf-viewer-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-top: 1px solid var(--border-color);
  background: var(--secondary-background);
}

.rtf-viewer-footer .download-link {
  background: var(--primary-color);
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rtf-viewer-footer .download-link:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
}

.rtf-viewer-footer .close-rtf-btn {
  background: var(--text-muted);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rtf-viewer-footer .close-rtf-btn:hover {
  background: var(--text-secondary);
}

/* Question Selection */
.question-selection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin: 20px 0;
}

.selected-question-info {
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 10px 15px;
  margin: 20px 0;
  text-align: center;
}

.selected-question-info p {
  margin: 0;
  color: var(--text-color);
  font-size: 0.9rem;
}

.selected-question-info strong {
  color: var(--accent-color);
}

.question-card {
  background: var(--secondary-background);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.question-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.question-card.selected {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: white;
}

.question-card.selected h4,
.question-card.selected p {
  color: white;
}

.question-card h4 {
  margin: 0 0 10px 0;
  color: var(--text-color);
  font-size: 1.1rem;
}

.question-card p {
  margin: 8px 0;
  color: var(--text-secondary);
  line-height: 1.5;
}

.question-card p strong {
  color: var(--accent-color);
  font-weight: 600;
}

.question-card.selected p strong {
  color: white;
}

.question-details {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.question-type,
.question-complexity {
  background: var(--background-color);
  color: var(--text-color);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}

.question-card.selected .question-type,
.question-card.selected .question-complexity {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

/* Plot Display */
.plot-section {
  margin: 20px 0;
}

.plot-container {
  background: var(--secondary-background);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
}

.analysis-plot {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* ADAS RTF Section */
.adas-rtf-section {
  margin-top: 20px;
  padding: 20px;
  background: var(--secondary-background);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.rtf-content-display {
  margin-top: 15px;
}

.rtf-content-display p {
  margin-bottom: 15px;
  color: var(--text-color);
  font-style: italic;
}

.rtf-files-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rtf-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: var(--background);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  transition: all 0.3s ease;
}

.rtf-file-item:hover {
  border-color: var(--primary-color);
  background: var(--hover-background);
}

.rtf-file-item .file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rtf-file-item .file-icon {
  font-size: 20px;
}

.rtf-file-item .file-name {
  font-weight: 500;
  color: var(--text-color);
}

.rtf-file-item .file-type {
  color: var(--secondary-text);
  font-size: 14px;
}

.rtf-file-item .file-actions {
  display: flex;
  gap: 10px;
}

/* ANCOVA RTF Document Preview */
.ancova-rtf-preview {
  margin-top: 20px;
  padding: 20px;
  background: var(--secondary-background);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

/* ADAS RTF Document Preview */
.adas-rtf-preview {
  margin-top: 20px;
  padding: 20px;
  background: var(--secondary-background);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.rtf-document-viewer {
  margin-top: 15px;
}

.rtf-document-container {
  background: var(--background);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.document-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: var(--primary-color);
  color: white;
  border-bottom: 1px solid var(--border-color);
}

.document-icon {
  font-size: 20px;
  margin-right: 10px;
}

.document-title {
  font-weight: 500;
  flex: 1 1;
}

.download-document-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.3s ease;
}

.download-document-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  color: white;
}

.document-content {
  height: 600px;
  border: none;
}

.rtf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

/* Dark theme overrides for question selection */
[data-theme="dark"] .question-card {
  background: #2d2d2d;
  border-color: #404040;
}

[data-theme="dark"] .question-card:hover {
  border-color: var(--primary-color);
}

[data-theme="dark"] .question-card.selected {
  background: var(--primary-color);
}

[data-theme="dark"] .question-type,
[data-theme="dark"] .question-complexity {
  background: #1a1a1a;
  color: #ffffff;
}

[data-theme="dark"] .plot-container {
  background: #2d2d2d;
  border-color: #404040;
}

[data-theme="dark"] .output-container {
  background: #0d1117;
  border-color: #30363d;
}

[data-theme="light"] .r-output {
  background: #f6f8fa;
  color: #24292f;
  border-color: #d0d7de;
}

[data-theme="light"] .output-container {
  background: #f6f8fa;
  border-color: #d0d7de;
}

/* Transparency Section */
.transparency-section {
  margin-bottom: 30px;
}

.transparency-tabs {
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
}

.tab-btn {
  background: none;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  color: var(--text-secondary);
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab-btn.active {
  color: var(--text-color);
  border-bottom-color: var(--primary-color);
}

.tab-btn:hover {
  color: var(--text-color);
}

.transparency-content {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 20px;
  background: var(--secondary-background);
}

.tab-content h4 {
  margin: 0 0 15px 0;
  color: var(--text-color);
}

.sap-summary pre {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 15px;
  overflow-x: auto;
  font-size: 0.9rem;
  color: var(--text-color);
  margin: 0;
}

/* Final Actions */
.final-actions {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}

.restart-btn {
  background: var(--secondary-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.restart-btn:hover {
  background: var(--hover-color);
}

.send-btn {
  background: var(--success-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.send-btn:hover {
  background: var(--success-dark);
}

/* Step Navigation */
.step-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.next-btn, .prev-btn, .close-btn {
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.next-btn {
  background: var(--primary-color);
  color: white;
}

.next-btn:hover:not(:disabled) {
  background: var(--primary-dark);
}

.next-btn:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
}

.prev-btn {
  background: var(--secondary-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
}

.prev-btn:hover {
  background: var(--hover-color);
}

.close-btn {
  background: var(--success-color);
  color: white;
}

.close-btn:hover {
  background: var(--success-dark);
}

/* Responsive Design */
@media (max-width: 768px) {
  .guided-run-modal {
    width: 95%;
    margin: 10px;
  }
  
  .guided-run-header {
    padding: 15px 20px;
  }
  
  .guided-run-content {
    padding: 20px;
  }
  
  .progress-bar {
    padding: 15px 20px;
  }
  
  .progress-step {
    min-width: 60px;
    margin-right: 10px;
  }
  
  .step-label {
    font-size: 0.7rem;
  }
  
  .dataset-grid, .document-grid {
    grid-template-columns: 1fr;
  }
  
  .final-actions {
    flex-direction: column;
  }
  
  .step-nav {
    flex-direction: column;
    gap: 10px;
  }
  
  .step-nav button {
    width: 100%;
  }
}

/* Dark theme variables */
[data-theme="dark"] {
  --primary-color: #4CAF50;
  --primary-dark: #45a049;
  --primary-light: rgba(76, 175, 80, 0.1);
  --accent-color: #FF9800;
  --accent-dark: #F57C00;
  --success-color: #4CAF50;
  --success-dark: #45a049;
  --secondary-color: #424242;
  --background-color: #1a1a1a;
  --secondary-background: #2d2d2d;
  --text-color: #ffffff;
  --text-secondary: #cccccc;
  --text-muted: #888888;
  --border-color: #404040;
  --hover-color: #3a3a3a;
}

/* Dark theme specific overrides for debug info */
[data-theme="dark"] .debug-info {
  background-color: #2d2d2d !important;
  color: #ffffff !important;
  border: 1px solid #404040 !important;
}

[data-theme="dark"] .debug-info strong {
  color: #4CAF50 !important;
}

[data-theme="dark"] .debug-info ul {
  color: #cccccc !important;
}

[data-theme="dark"] .debug-info li {
  color: #cccccc !important;
}

/* Light theme variables */
[data-theme="light"] {
  --primary-color: #2196F3;
  --primary-dark: #1976D2;
  --primary-light: rgba(33, 150, 243, 0.1);
  --accent-color: #FF9800;
  --accent-dark: #F57C00;
  --success-color: #4CAF50;
  --success-dark: #45a049;
  --secondary-color: #f5f5f5;
  --background-color: #ffffff;
  --secondary-background: #f9f9f9;
  --text-color: #333333;
  --text-secondary: #666666;
  --text-muted: #999999;
  --border-color: #e0e0e0;
  --hover-color: #f0f0f0;
}

/* Debug info styling */
.debug-info {
  background-color: #f0f0f0;
  color: #333333;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 5px;
}

.debug-info strong {
  color: #2196F3;
}

.debug-info ul {
  color: #666666;
  margin: 5px 0 0 0;
  padding-left: 20px;
}

.debug-info li {
  color: #666666;
}
`, "",{"version":3,"sources":["webpack://./src/components/GuidedRun.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iCAAiC;AACjC;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;EAME,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,wDAAwD;EACxD,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,uCAAuC;EACvC,qCAAqC;EACrC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,mEAAmE;EACnE,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,2BAA2B;EAC3B,6BAA6B;EAC7B,mEAAmE;EACnE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,4CAA4C;EAC5C,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,uCAAuC;EACvC,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wCAAwC;EACxC,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".guided-run-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.guided-run-modal {\n  background: var(--background-color);\n  border-radius: 12px;\n  width: 90%;\n  max-width: 1000px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--border-color);\n}\n\n.guided-run-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--secondary-background);\n}\n\n.guided-run-header h2 {\n  margin: 0;\n  color: var(--text-color);\n  font-size: 1.5rem;\n}\n\n.guided-run-header .close-btn {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: var(--text-color);\n  cursor: pointer;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.guided-run-header .close-btn:hover {\n  background-color: var(--hover-color);\n}\n\n.progress-bar {\n  display: flex;\n  padding: 20px 30px;\n  background: var(--secondary-background);\n  border-bottom: 1px solid var(--border-color);\n  overflow-x: auto;\n}\n\n.progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 20px;\n  min-width: 80px;\n  position: relative;\n}\n\n.progress-step:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  top: 15px;\n  left: 60px;\n  width: 20px;\n  height: 2px;\n  background-color: var(--border-color);\n  z-index: 1;\n}\n\n.progress-step.active:not(:last-child)::after {\n  background-color: var(--primary-color);\n}\n\n.step-number {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: var(--border-color);\n  color: var(--text-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  margin-bottom: 5px;\n  z-index: 2;\n  position: relative;\n}\n\n.progress-step.active .step-number {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.progress-step.current .step-number {\n  background-color: var(--accent-color);\n  color: white;\n  box-shadow: 0 0 10px var(--accent-color);\n}\n\n.step-label {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.progress-step.active .step-label {\n  color: var(--text-color);\n}\n\n.guided-run-content {\n  padding: 30px;\n  max-height: calc(90vh - 200px);\n  overflow-y: auto;\n}\n\n.guided-step {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.guided-step h3 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n  font-size: 1.3rem;\n}\n\n.guided-step p {\n  margin: 0 0 20px 0;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n/* Study Cards */\n.study-cards {\n  display: grid;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.study-card {\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: var(--background-color);\n}\n\n.study-card:hover {\n  border-color: var(--primary-color);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.study-card.selected {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.study-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.study-header h4 {\n  margin: 0;\n  color: var(--text-color);\n  font-size: 1.1rem;\n}\n\n.study-badge {\n  background: var(--primary-color);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: bold;\n}\n\n.study-description {\n  margin: 0 0 15px 0;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.study-links a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.study-links a:hover {\n  text-decoration: underline;\n}\n\n.study-assets {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n/* Dataset and Document Grids */\n.dataset-grid, .document-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.dataset-card, .document-card {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 15px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: var(--background-color);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dataset-card:hover, .document-card:hover {\n  border-color: var(--primary-color);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dataset-card.selected, .document-card.selected {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.dataset-icon, .document-icon {\n  font-size: 2rem;\n  flex-shrink: 0;\n}\n\n.dataset-info, .document-info {\n  flex: 1;\n}\n\n.dataset-info h4, .document-info h4 {\n  margin: 0 0 5px 0;\n  color: var(--text-color);\n  font-size: 1rem;\n}\n\n.dataset-info p, .document-info p {\n  margin: 0 0 5px 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.dataset-size, .document-size {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n/* Preview Containers */\n.preview-container {\n  margin-top: 20px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  background: var(--secondary-background);\n}\n\n.preview-container h4 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n}\n\n.table-container {\n  overflow-x: auto;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.preview-table, .results-table-content {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.preview-table th, .preview-table td,\n.results-table-content th, .results-table-content td {\n  border: 1px solid var(--border-color);\n  padding: 8px;\n  text-align: left;\n}\n\n.preview-table th, .results-table-content th {\n  background: var(--secondary-background);\n  font-weight: bold;\n  color: var(--text-color);\n}\n\n.preview-table td, .results-table-content td {\n  color: var(--text-secondary);\n}\n\n.document-preview {\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n/* Analysis Question */\n.analysis-question {\n  margin-bottom: 30px;\n}\n\n.question-card {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  background: var(--secondary-background);\n}\n\n.question-card p {\n  margin: 0 0 10px 0;\n}\n\n.question-card p:last-child {\n  margin: 0;\n}\n\n/* SAP Section */\n.sap-section {\n  margin-bottom: 30px;\n}\n\n.sap-btn {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-bottom: 20px;\n}\n\n.sap-btn:hover:not(:disabled) {\n  background: var(--primary-dark);\n}\n\n.sap-btn:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.sap-results {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  background: var(--secondary-background);\n}\n\n.sap-results h4 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n}\n\n.sap-content pre {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 15px;\n  overflow-x: auto;\n  font-size: 0.9rem;\n  color: var(--text-color);\n  margin: 0;\n}\n\n/* SAP Loading Styles */\n.sap-loading {\n  margin-top: 20px;\n  padding: 30px;\n  text-align: center;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--secondary-background);\n}\n\n.loading-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.loading-message p {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--text-color);\n  font-weight: 500;\n}\n\n.loading-subtitle {\n  font-size: 0.9rem !important;\n  color: var(--text-secondary) !important;\n  font-weight: 400 !important;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid #ffffff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-right: 8px;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.sap-loading .spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid var(--border-color);\n  border-top: 3px solid var(--primary-color);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* SAP Content Markdown Styling */\n.sap-content {\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.sap-content h1,\n.sap-content h2,\n.sap-content h3,\n.sap-content h4,\n.sap-content h5,\n.sap-content h6 {\n  color: var(--text-color);\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.sap-content h1:first-child,\n.sap-content h2:first-child,\n.sap-content h3:first-child {\n  margin-top: 0;\n}\n\n.sap-content p {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 12px;\n}\n\n.sap-content ul,\n.sap-content ol {\n  color: var(--text-secondary);\n  padding-left: 20px;\n  margin-bottom: 12px;\n}\n\n.sap-content li {\n  margin-bottom: 6px;\n}\n\n.sap-content strong {\n  color: var(--accent-color);\n  font-weight: 600;\n}\n\n.sap-content code {\n  background: var(--background-color);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.9em;\n  color: var(--text-color);\n  border: 1px solid var(--border-color);\n}\n\n.sap-content pre {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 15px;\n  overflow-x: auto;\n  margin: 15px 0;\n}\n\n.sap-content pre code {\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n/* Code Generation */\n.code-generation {\n  margin-bottom: 30px;\n}\n\n/* R Code Loading Styles */\n.r-code-loading {\n  margin-top: 20px;\n  padding: 30px;\n  text-align: center;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--secondary-background);\n}\n\n/* Code Actions */\n.code-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.toggle-code-btn,\n.copy-code-btn {\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  color: var(--text-color);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.toggle-code-btn:hover,\n.copy-code-btn:hover {\n  background: var(--hover-color);\n  border-color: var(--primary-color);\n}\n\n.copy-code-btn {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n.copy-code-btn:hover {\n  background: var(--primary-dark);\n}\n\n/* R Code Display */\n.r-code-pre {\n  background: #1e1e1e !important;\n  color: #d4d4d4 !important;\n  padding: 20px !important;\n  border-radius: 8px !important;\n  overflow-x: auto !important;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n  font-size: 14px !important;\n  line-height: 1.5 !important;\n  border: 1px solid #333 !important;\n  margin: 15px 0 !important;\n}\n\n.r-code-inline {\n  background: var(--secondary-background) !important;\n  color: var(--text-color) !important;\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n  font-size: 0.9em !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n/* Raw Code Section */\n.raw-code-section {\n  margin-top: 20px;\n  padding: 15px;\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n}\n\n.raw-code-section h5 {\n  margin: 0 0 10px 0;\n  color: var(--text-color);\n  font-size: 1rem;\n}\n\n.raw-code {\n  background: #1e1e1e;\n  color: #d4d4d4;\n  padding: 15px;\n  border-radius: 6px;\n  overflow-x: auto;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 13px;\n  line-height: 1.4;\n  border: 1px solid #333;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Code Content */\n.code-content {\n  margin-top: 15px;\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 0;\n  overflow: hidden;\n}\n\n/* Dark theme overrides for code */\n[data-theme=\"dark\"] .r-code-pre {\n  background: #0d1117 !important;\n  color: #c9d1d9 !important;\n  border-color: #30363d !important;\n}\n\n[data-theme=\"dark\"] .raw-code {\n  background: #0d1117;\n  color: #c9d1d9;\n  border-color: #30363d;\n}\n\n[data-theme=\"dark\"] .code-content {\n  background: var(--secondary-background);\n  border-color: var(--border-color);\n}\n\n/* Light theme overrides for code */\n[data-theme=\"light\"] .r-code-pre {\n  background: #f6f8fa !important;\n  color: #24292f !important;\n  border-color: #d0d7de !important;\n}\n\n[data-theme=\"light\"] .raw-code {\n  background: #f6f8fa;\n  color: #24292f;\n  border-color: #d0d7de;\n}\n\n.generate-btn, .run-btn {\n  background: var(--accent-color);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-bottom: 20px;\n}\n\n.generate-btn:hover:not(:disabled), .run-btn:hover:not(:disabled) {\n  background: var(--accent-dark);\n}\n\n.generate-btn:disabled, .run-btn:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.code-results {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  background: var(--secondary-background);\n}\n\n.code-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.code-header h4 {\n  margin: 0;\n  color: var(--text-color);\n}\n\n.toggle-btn {\n  background: var(--secondary-color);\n  color: var(--text-color);\n  border: 1px solid var(--border-color);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.toggle-btn:hover {\n  background: var(--hover-color);\n}\n\n.code-content {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 15px;\n  overflow-x: auto;\n}\n\n.code-content pre {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text-color);\n  white-space: pre-wrap;\n}\n\n/* Analysis Results */\n.analysis-execution {\n  margin-bottom: 30px;\n}\n\n.analysis-results {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  background: var(--secondary-background);\n  margin-top: 20px;\n}\n\n.analysis-results h4 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n}\n\n.results-content h5 {\n  margin: 0 0 10px 0;\n  color: var(--text-color);\n}\n\n.result-file {\n  margin: 10px 0;\n}\n\n.download-link {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 8px 16px;\n  border: 1px solid var(--primary-color);\n  border-radius: 4px;\n  display: inline-block;\n  transition: all 0.2s;\n}\n\n.download-link:hover {\n  background: var(--primary-color);\n  color: white;\n}\n\n/* Enhanced Analysis Results */\n.results-content {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n/* R Output Section */\n.r-output-section {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.r-output-section h5 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.output-container {\n  background: #1e1e1e;\n  border: 1px solid #333;\n  border-radius: 6px;\n  padding: 15px;\n  overflow-x: auto;\n}\n\n.r-output {\n  color: #d4d4d4;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Enhanced Results Table */\n.results-table {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.results-table h5 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.table-container {\n  overflow-x: auto;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--background-color);\n}\n\n.results-table-content {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--background-color);\n  min-width: 600px;\n}\n\n.results-table-content th,\n.results-table-content td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color);\n  border-right: 1px solid var(--border-color);\n}\n\n.results-table-content th {\n  background: var(--secondary-background);\n  font-weight: 600;\n  color: var(--text-color);\n  font-size: 0.9rem;\n}\n\n.results-table-content td {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.results-table-content tr:hover {\n  background: var(--hover-color);\n}\n\n/* Enhanced Generated Files */\n.generated-files {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.generated-files h5 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.result-file {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  margin: 0;\n}\n\n.result-file:hover {\n  background: var(--hover-color);\n  border-color: var(--primary-color);\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.file-icon {\n  font-size: 1.2rem;\n}\n\n.file-name {\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.file-type {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  background: var(--background-color);\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n/* File Actions */\n.file-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.view-file-btn {\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  color: var(--text-color);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.view-file-btn:hover {\n  background: var(--hover-color);\n  border-color: var(--primary-color);\n}\n\n/* RTF Viewer Modal */\n.rtf-viewer-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.rtf-viewer-content {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.rtf-viewer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--secondary-background);\n}\n\n.rtf-viewer-header h3 {\n  margin: 0;\n  color: var(--text-color);\n  font-size: 1.2rem;\n}\n\n.close-rtf-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-rtf-btn:hover {\n  background: var(--hover-color);\n  color: var(--text-color);\n}\n\n.rtf-viewer-body {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.rtf-file-info {\n  padding: 15px 20px;\n  background: var(--secondary-background);\n  border-bottom: 1px solid var(--border-color);\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.rtf-content {\n  flex: 1;\n  overflow: auto;\n  padding: 20px;\n}\n\n.rtf-content pre {\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 20px;\n  margin: 0;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text-color);\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.rtf-viewer-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-top: 1px solid var(--border-color);\n  background: var(--secondary-background);\n}\n\n.rtf-viewer-footer .download-link {\n  background: var(--primary-color);\n  color: white;\n  text-decoration: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.rtf-viewer-footer .download-link:hover {\n  background: var(--primary-dark);\n  transform: translateY(-1px);\n}\n\n.rtf-viewer-footer .close-rtf-btn {\n  background: var(--text-muted);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.rtf-viewer-footer .close-rtf-btn:hover {\n  background: var(--text-secondary);\n}\n\n/* Question Selection */\n.question-selection {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin: 20px 0;\n}\n\n.selected-question-info {\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 10px 15px;\n  margin: 20px 0;\n  text-align: center;\n}\n\n.selected-question-info p {\n  margin: 0;\n  color: var(--text-color);\n  font-size: 0.9rem;\n}\n\n.selected-question-info strong {\n  color: var(--accent-color);\n}\n\n.question-card {\n  background: var(--secondary-background);\n  border: 2px solid var(--border-color);\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.question-card:hover {\n  border-color: var(--primary-color);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.question-card.selected {\n  border-color: var(--primary-color);\n  background: var(--primary-color);\n  color: white;\n}\n\n.question-card.selected h4,\n.question-card.selected p {\n  color: white;\n}\n\n.question-card h4 {\n  margin: 0 0 10px 0;\n  color: var(--text-color);\n  font-size: 1.1rem;\n}\n\n.question-card p {\n  margin: 8px 0;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.question-card p strong {\n  color: var(--accent-color);\n  font-weight: 600;\n}\n\n.question-card.selected p strong {\n  color: white;\n}\n\n.question-details {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.question-type,\n.question-complexity {\n  background: var(--background-color);\n  color: var(--text-color);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.question-card.selected .question-type,\n.question-card.selected .question-complexity {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n/* Plot Display */\n.plot-section {\n  margin: 20px 0;\n}\n\n.plot-container {\n  background: var(--secondary-background);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  text-align: center;\n}\n\n.analysis-plot {\n  max-width: 100%;\n  height: auto;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* ADAS RTF Section */\n.adas-rtf-section {\n  margin-top: 20px;\n  padding: 20px;\n  background: var(--secondary-background);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.rtf-content-display {\n  margin-top: 15px;\n}\n\n.rtf-content-display p {\n  margin-bottom: 15px;\n  color: var(--text-color);\n  font-style: italic;\n}\n\n.rtf-files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rtf-file-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background: var(--background);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.rtf-file-item:hover {\n  border-color: var(--primary-color);\n  background: var(--hover-background);\n}\n\n.rtf-file-item .file-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rtf-file-item .file-icon {\n  font-size: 20px;\n}\n\n.rtf-file-item .file-name {\n  font-weight: 500;\n  color: var(--text-color);\n}\n\n.rtf-file-item .file-type {\n  color: var(--secondary-text);\n  font-size: 14px;\n}\n\n.rtf-file-item .file-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* ANCOVA RTF Document Preview */\n.ancova-rtf-preview {\n  margin-top: 20px;\n  padding: 20px;\n  background: var(--secondary-background);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n/* ADAS RTF Document Preview */\n.adas-rtf-preview {\n  margin-top: 20px;\n  padding: 20px;\n  background: var(--secondary-background);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.rtf-document-viewer {\n  margin-top: 15px;\n}\n\n.rtf-document-container {\n  background: var(--background);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.document-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px 20px;\n  background: var(--primary-color);\n  color: white;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.document-icon {\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.document-title {\n  font-weight: 500;\n  flex: 1;\n}\n\n.download-document-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 14px;\n  transition: background 0.3s ease;\n}\n\n.download-document-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  color: white;\n}\n\n.document-content {\n  height: 600px;\n  border: none;\n}\n\n.rtf-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: white;\n}\n\n/* Dark theme overrides for question selection */\n[data-theme=\"dark\"] .question-card {\n  background: #2d2d2d;\n  border-color: #404040;\n}\n\n[data-theme=\"dark\"] .question-card:hover {\n  border-color: var(--primary-color);\n}\n\n[data-theme=\"dark\"] .question-card.selected {\n  background: var(--primary-color);\n}\n\n[data-theme=\"dark\"] .question-type,\n[data-theme=\"dark\"] .question-complexity {\n  background: #1a1a1a;\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .plot-container {\n  background: #2d2d2d;\n  border-color: #404040;\n}\n\n[data-theme=\"dark\"] .output-container {\n  background: #0d1117;\n  border-color: #30363d;\n}\n\n[data-theme=\"light\"] .r-output {\n  background: #f6f8fa;\n  color: #24292f;\n  border-color: #d0d7de;\n}\n\n[data-theme=\"light\"] .output-container {\n  background: #f6f8fa;\n  border-color: #d0d7de;\n}\n\n/* Transparency Section */\n.transparency-section {\n  margin-bottom: 30px;\n}\n\n.transparency-tabs {\n  display: flex;\n  gap: 5px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.tab-btn {\n  background: none;\n  border: none;\n  padding: 10px 15px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab-btn.active {\n  color: var(--text-color);\n  border-bottom-color: var(--primary-color);\n}\n\n.tab-btn:hover {\n  color: var(--text-color);\n}\n\n.transparency-content {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 20px;\n  background: var(--secondary-background);\n}\n\n.tab-content h4 {\n  margin: 0 0 15px 0;\n  color: var(--text-color);\n}\n\n.sap-summary pre {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 15px;\n  overflow-x: auto;\n  font-size: 0.9rem;\n  color: var(--text-color);\n  margin: 0;\n}\n\n/* Final Actions */\n.final-actions {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.restart-btn {\n  background: var(--secondary-color);\n  color: var(--text-color);\n  border: 1px solid var(--border-color);\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.restart-btn:hover {\n  background: var(--hover-color);\n}\n\n.send-btn {\n  background: var(--success-color);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.send-btn:hover {\n  background: var(--success-dark);\n}\n\n/* Step Navigation */\n.step-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.next-btn, .prev-btn, .close-btn {\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.next-btn {\n  background: var(--primary-color);\n  color: white;\n}\n\n.next-btn:hover:not(:disabled) {\n  background: var(--primary-dark);\n}\n\n.next-btn:disabled {\n  background: var(--text-muted);\n  cursor: not-allowed;\n}\n\n.prev-btn {\n  background: var(--secondary-color);\n  color: var(--text-color);\n  border: 1px solid var(--border-color);\n}\n\n.prev-btn:hover {\n  background: var(--hover-color);\n}\n\n.close-btn {\n  background: var(--success-color);\n  color: white;\n}\n\n.close-btn:hover {\n  background: var(--success-dark);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .guided-run-modal {\n    width: 95%;\n    margin: 10px;\n  }\n  \n  .guided-run-header {\n    padding: 15px 20px;\n  }\n  \n  .guided-run-content {\n    padding: 20px;\n  }\n  \n  .progress-bar {\n    padding: 15px 20px;\n  }\n  \n  .progress-step {\n    min-width: 60px;\n    margin-right: 10px;\n  }\n  \n  .step-label {\n    font-size: 0.7rem;\n  }\n  \n  .dataset-grid, .document-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .final-actions {\n    flex-direction: column;\n  }\n  \n  .step-nav {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .step-nav button {\n    width: 100%;\n  }\n}\n\n/* Dark theme variables */\n[data-theme=\"dark\"] {\n  --primary-color: #4CAF50;\n  --primary-dark: #45a049;\n  --primary-light: rgba(76, 175, 80, 0.1);\n  --accent-color: #FF9800;\n  --accent-dark: #F57C00;\n  --success-color: #4CAF50;\n  --success-dark: #45a049;\n  --secondary-color: #424242;\n  --background-color: #1a1a1a;\n  --secondary-background: #2d2d2d;\n  --text-color: #ffffff;\n  --text-secondary: #cccccc;\n  --text-muted: #888888;\n  --border-color: #404040;\n  --hover-color: #3a3a3a;\n}\n\n/* Dark theme specific overrides for debug info */\n[data-theme=\"dark\"] .debug-info {\n  background-color: #2d2d2d !important;\n  color: #ffffff !important;\n  border: 1px solid #404040 !important;\n}\n\n[data-theme=\"dark\"] .debug-info strong {\n  color: #4CAF50 !important;\n}\n\n[data-theme=\"dark\"] .debug-info ul {\n  color: #cccccc !important;\n}\n\n[data-theme=\"dark\"] .debug-info li {\n  color: #cccccc !important;\n}\n\n/* Light theme variables */\n[data-theme=\"light\"] {\n  --primary-color: #2196F3;\n  --primary-dark: #1976D2;\n  --primary-light: rgba(33, 150, 243, 0.1);\n  --accent-color: #FF9800;\n  --accent-dark: #F57C00;\n  --success-color: #4CAF50;\n  --success-dark: #45a049;\n  --secondary-color: #f5f5f5;\n  --background-color: #ffffff;\n  --secondary-background: #f9f9f9;\n  --text-color: #333333;\n  --text-secondary: #666666;\n  --text-muted: #999999;\n  --border-color: #e0e0e0;\n  --hover-color: #f0f0f0;\n}\n\n/* Debug info styling */\n.debug-info {\n  background-color: #f0f0f0;\n  color: #333333;\n  border: 1px solid #e0e0e0;\n  margin-bottom: 20px;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.debug-info strong {\n  color: #2196F3;\n}\n\n.debug-info ul {\n  color: #666666;\n  margin: 5px 0 0 0;\n  padding-left: 20px;\n}\n\n.debug-info li {\n  color: #666666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
